// extracted by mini-css-extract-plugin
export default {"desktop":"aeFlA","nav":"siv3b"};